var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"edit-patient-info-modal","classes":['modal-window'],"transition":"scale","scrollable":true,"adaptive":true,"reset":true,"click-to-close":false,"width":"835","height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('EditPatientInfo',{attrs:{"patient-photo":_vm.patientPhoto}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }